import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  window.console.log = () => { };
}

platformBrowserDynamic().bootstrapModule(AppModule).then(() => {
  // if ('serviceWorker' in navigator && !environment.production) {
  //   navigator.serviceWorker.register("ngsw-worker.js")
  //     .then((registration) => {
  //       console.log("Registration succeeded.");
  //       registration.unregister().then((boolean) => {
  //         if (boolean) {
  //           console.log("Unregistration succeeded.");
  //         }
  //       });
  //     })
  //     .catch((error) => {
  //       // registration failed
  //       console.error(`Registration failed with ${error}`);
  //     });
  // }
  // if ('serviceWorker' in navigator && environment.production) {
  //   navigator.serviceWorker.register('ngsw-worker.js');
  // }
})
  .catch(err => console.error(err));
